module.exports = __webpack_public_path__ + "img/NCC2010A_1-1.6293bdba.png";